var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"media"},_vm._l((_vm.linksItems),function(linksItem){return _c('MediaLinksItem',{key:linksItem.id,attrs:{"linksItem":linksItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }